import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Primitive, type PrimitiveProps } from 'reka-ui';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BreadcrumbLink',
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function], default: 'a' },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Primitive), {
    "data-slot": "breadcrumb-link",
    as: _ctx.as,
    "as-child": _ctx.asChild,
    class: _normalizeClass(_unref(cn)('text-primary hover:text-primary-dark transition-colors', props.class))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as", "as-child", "class"]))
}
}

})